/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import debounce from "lodash.debounce";
// @ts-expect-error TS(7016): Could not find a declaration file for module 'loda... Remove this comment to see the full error message
import isEqual from "lodash.isequal";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import {
  trackRudderstackImageEdited,
  trackRudderstackImagePlacementSelection,
  trackRudderstackImagePlacementQuantity
} from "common/utils/rudderstack/tracker.react";
// @ts-expect-error TS(6133): 'useMemo' is declared but its value is never read.
import { useState, useEffect, useLayoutEffect, useRef, useMemo, Fragment } from "react";
import useArtworkValidation from "../common/composables/useArtworkValidation";
import QuantityInput from "./QuantityInput.vue";
import CustomSizeSelector from "./CustomSizeSelector.vue";
import PresetSelector from "./PresetSelector.vue";
import MultiSizeGroup from "./MultiSizeGroup.vue";
import SizeGuide from "./SizeGuide.vue";
import FreeTransfersBadge from "../common/FreeTransfersBadge.vue";
import {
  MIN_DPI,
  PRINT_AS_IS_MIN_DPI,
  PRINT_AS_IS_MIN_WIDTH,
  MAX_SIZE_FIELD_VALUE,
  DEFAULT_VALUES,
  GANG_DEFAULT_VALUES,
  MAX_QUANTITY_VALUE,
  MAX_PRINT_SIZES_GROUPED
} from "../common/constants";
import { getRandomId, getTitleCaseString, scaleToFitRatio } from "../utils";
import {
  getImageMetadataInfo,
  getRangeString,
  groupByPreset,
  isWidthAndHeightValid,
  getProportionalEdge
} from "./utils";
import { useI18n } from "intl/useI18n";
import { useDtfStore } from "../store";
import "./ArtworkMultiDimensions.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

function ArtworkMultiDimensions({
  artwork: artworkProp = null,
  index = 0,
  disabled = false,
  readonly = false,
  isMultiUpload = false,
  showFreeTransfersBadge = false,
  // @ts-expect-error TS(7031): Binding element 'restClassName' implicitly has an ... Remove this comment to see the full error message
  className: restClassName,
  ...restProps
}) {
  const { n } = useI18n();
  const store = useDtfStore();

  // Read artwork from store to avoid stale prop/closure issues.
  // Props may lag behind store updates due to React's batched rendering.
  // Uses a getter function so every access reads the latest store state.
  function getStoreArtwork() {
    return (
      // @ts-expect-error TS migration
      store.artworks?.find((a: any) => a?.id === artworkProp?.id) ||
      // @ts-expect-error TS migration
      store.artworks?.[index] ||
      artworkProp
    );
  }
  const artwork = getStoreArtwork();

  const [previousData, setPreviousData] = useState([
    {
      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      width: store.printAsIs ? GANG_DEFAULT_VALUES.width : DEFAULT_VALUES.width,
      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      height: store.printAsIs ? GANG_DEFAULT_VALUES.height : DEFAULT_VALUES.height
    }
  ]);
  const [errors, setErrors] = useState({});
  const [sizeGuidePreset, setSizeGuidePreset] = useState(null);
  const [sizeChanged, setSizeChanged] = useState(false);
  const [backgroundChanged, setBackgroundChanged] = useState({
    changed: false,
    isBgRemoved: false
  });
  const backgroundChangedRef = useRef(backgroundChanged);
  backgroundChangedRef.current = backgroundChanged;

  const prevArtworkRef = useRef(artwork);
  const prevMetadataRef = useRef(null);

  function artworkUrl() {
    return artwork?.manualEditUrl || artwork?.url;
  }

  function isPricingLoading() {
    // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
    return store.isPricingLoading;
  }

  function printAsIs() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return store.printAsIs;
  }

  function showMultiSize() {
    // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
    return store.showMultiSize;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  function sticker() {
    // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
    return store.sticker;
  }

  function proColor() {
    // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
    return store.isProColor;
  }

  function variantId() {
    // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
    return store.variantId;
  }

  function gangPadlock() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return printAsIs() && !store.showModal;
  }

  function lockHeight() {
    return gangPadlock() && !!metadata();
  }

  function editType() {
    if (sizeChanged) {
      return "Size Adjustment";
    }
    if (artwork?.enhanceImage) {
      return "Jiffy Print Perfect";
    }
    return "Print as uploaded";
  }

  function isArtworkLoading() {
    return artwork?.isLoading || (isStandardArtwork() && !artwork?.enhancementCompleted);
  }

  function isArtworkUploaded() {
    const artworkId = parseInt(artwork?.id, 10);
    if (Number.isNaN(artworkId)) {
      return false;
    }
    if (isStandardArtwork()) {
      return !artwork?.isLoading && artwork?.enhancementCompleted;
    }
    return typeof artworkId === "number" && !artwork?.isLoading;
  }

  function showPricing() {
    return index === 0 || isArtworkUploaded();
  }

  function disableFields() {
    return disabled;
  }

  const defaultCustomSizeIdRef = useRef(getRandomId());

  function defaultCustomSize() {
    // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
    const values = index === 0 ? store.simulation : store.initialValues;
    return [
      {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        width: values.width,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        height: values.height,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        quantity: values.quantity,
        preset: "custom",
        id: defaultCustomSizeIdRef.current
      }
    ];
  }

  const sizesAndQuantities =
    artwork?.sizesAndQuantities?.length > 0 ? artwork.sizesAndQuantities : defaultCustomSize();

  function sizesGroupedByPreset() {
    const grouped = groupByPreset(sizesAndQuantities);
    const artworkId = String(artwork?.id);
    Object.values(grouped).forEach(group => {
      let bogoAdjustedPrice = 0;
      let hasBogoPrice = false;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      group.items.forEach((item: any) => {
        const sizeKey = `${item.width}x${item.height}`;
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const bogoPrice = store.getBogoAdjustedPrice(artworkId, item.id, sizeKey);
        if (bogoPrice) {
          bogoAdjustedPrice += bogoPrice.discountedTotalPrice;
          hasBogoPrice = true;
        } else if (item.unitPrice) {
          bogoAdjustedPrice += Number(item.unitPrice) * item.quantity;
        }
      });
      if (hasBogoPrice) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        group.price = bogoAdjustedPrice;
      }
    });
    if (grouped.custom) {
      const { custom, ...others } = grouped;
      return {
        ...others,
        custom
      };
    }
    return grouped;
  }

  function selectedPresets() {
    return Object.keys(sizesGroupedByPreset());
  }

  function errorGroupedByPreset() {
    return Object.values(errors).reduce(
      (acc, error) => ({
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...acc,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        [error.preset]: [...(acc[error.preset] || []), error]
      }),
      {}
    );
  }

  function readonlyHeight() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    if (store.showModal && store.printAsIs) return readonly;
    if (!lockHeight()) return false;
    return readonly;
  }

  function widthId() {
    // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
    return `artwork[${index}][variants][${store.variantId}][width]`;
  }

  function heightId() {
    // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
    return `artwork[${index}][variants][${store.variantId}][height]`;
  }

  function metadata() {
    const metadataSource = artwork;
    const { metadata: artworkMetadata, withBgMetadata } = metadataSource || {};
    const { removeBackground } = artwork || {};
    if (!withBgMetadata || Object.keys(withBgMetadata).length === 0) {
      return artworkMetadata;
    }
    return removeBackground ? artworkMetadata : withBgMetadata;
  }

  function minDpi() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    if (store.printAsIs) return PRINT_AS_IS_MIN_DPI;
    return metadata()?.upscalingEnabled ? Number(metadata().qualityUpscaleDpi) : MIN_DPI;
  }

  function heightLabel() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return store.printAsIs ? "Length (Feet)" : "Height (Inch)";
  }

  function minWidthSetting() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return store.printAsIs ? PRINT_AS_IS_MIN_WIDTH : store.dtfMinWidth;
  }

  function imageMetadataInfo() {
    return getImageMetadataInfo({
      metadata: metadata(),
      sizesAndQuantities,
      minDpi: minDpi(),
      artwork
    });
  }

  function sizePresets() {
    if (!artwork?.width || !artwork?.height) {
      return [];
    }
    return Object.entries(MAX_PRINT_SIZES_GROUPED)
      .map(([key, dimensions]) => ({
        id: key,
        isValid: dimensions.every(({ width, height }) => {
          if (!metadata()?.aspectRatio) return false;
          const scaledSize = scaleToFitRatio(width, height, metadata().aspectRatio);
          return scaledSize.width >= 1 && scaledSize.height >= 1;
        }),
        title: getTitleCaseString(key)
      }))
      .filter(item => item.isValid);
  }

  function allowedPresets() {
    return sizePresets().map(preset => preset.id);
  }

  function blankItemsCount() {
    // @ts-expect-error TS(4111): Property 'blankItemsCount' comes from an index sig... Remove this comment to see the full error message
    return store.blankItemsCount;
  }

  function transfersInCartCount() {
    // @ts-expect-error TS(4111): Property 'transfersInCartCount' comes from an inde... Remove this comment to see the full error message
    return store.transfersInCartCount;
  }

  function selectedQuantityTotal() {
    return sizesAndQuantities.reduce(
      (total: any, size: any) => total + (parseInt(size.quantity, 10) || 0),
      0
    );
  }

  function totalTransfersCount() {
    // @ts-expect-error TS(4111): Property 'totalQuantity' comes from an index signa... Remove this comment to see the full error message
    const currentQuantity = isMultiUpload ? store.totalQuantity : selectedQuantityTotal();
    const cartTransfers = transfersInCartCount() || 0;
    return currentQuantity + cartTransfers;
  }

  function remainingFreeTransfers() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Math.max(0, blankItemsCount() - totalTransfersCount());
  }

  function freeTransfersBadgeMessage() {
    return `${remainingFreeTransfers()} of ${blankItemsCount()} FREE Transfers Left`;
  }

  // useRef keeps a single debounce instance across renders — creating debounce() inline would
  // create a new instance on every render, causing stale timers to accumulate and fire
  // independently, multiplying pricing requests for each size change.
  const loadPricingAndDatesRef = useRef(
    debounce(() => {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.getArtworksPricing();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.updatePdpDates();
    }, 2500)
  );

  function getNewPricingAndDates() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.setIsPricingLoading(true);
    loadPricingAndDatesRef.current();
  }

  async function updateSizesAndQuantities(newSizesAndQuantities: any, isSizesEdited = false) {
    const currentArtwork = getStoreArtwork();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: currentArtwork.originalIndex,
      isSizesEdited,
      ...{
        sizesAndQuantities: newSizesAndQuantities
      }
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updatePreviewDpi({
      artworkId: currentArtwork.id
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    await store.downscaleOriginalImage({
      artworkId: currentArtwork.id
    });
    getNewPricingAndDates();
  }

  function calculateCustomDimensions(size: any) {
    return {
      width: size.width,
      height: getProportionalEdge({
        value: size.width,
        field: "height",
        aspectRatio: metadata()?.aspectRatio,
        currentDimensions: sizesAndQuantities[sizesAndQuantities.length - 1]
      })
    };
  }

  function calculatePresetDimensions({ size, preset }: any) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const presetSize = MAX_PRINT_SIZES_GROUPED[preset].find(
      (item: any) => size === getRangeString(item)
    );
    if (!presetSize || !metadata()?.aspectRatio) return null;
    return scaleToFitRatio(presetSize.width, presetSize.height, metadata().aspectRatio);
  }

  function resetErrors() {
    setErrors({});
  }

  function sendValidationEvent(eventType: any, errorType: any, data: any) {
    let validationMetadata = {
      ...data,
      has_image: !artwork?.isFile && !artwork?.isSimulated,
      // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
      pdp_type: store.pdpType,
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      business_line: store.businessLine,
      page: "pdp"
    };
    if (!artwork?.isFile) {
      validationMetadata = {
        ...validationMetadata,
        ...imageMetadataInfo()
      };
    }
    submitDtfEvent(eventType, {
      type: errorType,
      ...validationMetadata
    });
  }

  function buildValidationConfig() {
    return {
      minWidth: minWidthSetting(),
      // @ts-expect-error TS(4111): Property 'dtfMinHeight' comes from an index signat... Remove this comment to see the full error message
      minHeight: store.dtfMinHeight,
      // @ts-expect-error TS(4111): Property 'dtfMaxWidth' comes from an index signatu... Remove this comment to see the full error message
      maxWidth: store.dtfMaxWidth,
      // @ts-expect-error TS(4111): Property 'dtfMaxHeight' comes from an index signat... Remove this comment to see the full error message
      maxHeight: store.dtfMaxHeight,
      isPrintAsIs: printAsIs(),
      metadata: metadata(),
      originalDimensions: {
        originalWidth: artwork?.width,
        originalHeight: artwork?.height
      },
      onValidation: sendValidationEvent
    };
  }

  function sendValidationWarningEvent() {
    const warning = artwork?.metadata?.warnings?.keys[0];
    if (!printAsIs() || !warning) return;
    const validationMetadata = {
      ...imageMetadataInfo(),
      has_image: !artwork?.isFile && !artwork?.isSimulated,
      // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
      pdp_type: store.pdpType,
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      business_line: store.businessLine,
      page: "pdp"
    };
    submitDtfEvent("image_validation_warning", {
      type: warning,
      ...validationMetadata
    });
  }

  function setValidationErrorMessageToArtwork() {
    const errorList = Object.values(errors);
    const firstError = errorList[0];
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.setValidationErrorMessage({
      index: artwork.originalIndex,
      isMultiSizeError: errorList.length > 0,
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      message: firstError?.message || null,
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      type: firstError?.type || null
    });
  }

  // @ts-expect-error TS(2345): Argument of type '{ minWidth: unknown; minHeight: ... Remove this comment to see the full error message
  const validator = useArtworkValidation(buildValidationConfig());

  function validateValues() {
    if (printAsIs() && !artwork?.isSimulated) return;
    resetErrors();
    const activeSizes = sizesAndQuantities.filter(({ quantity }: any) => Number(quantity) > 0);
    const validationErrors = Object.fromEntries(
      activeSizes
        .map((item: any) => {
          const error = validator.validateDimensions(item);
          return error ? [item.id, error] : null;
        })
        .filter(Boolean)
    );
    setErrors(validationErrors);
    setValidationErrorMessageToArtwork();
    sendValidationWarningEvent();
  }

  async function recalculateSizes() {
    const newSizes = sizesAndQuantities
      .filter((size: any) => allowedPresets().includes(size.preset))
      .map((size: any) => {
        const newDimensions =
          size.preset === "custom"
            ? calculateCustomDimensions(size)
            : calculatePresetDimensions(size);
        return {
          ...size,
          ...newDimensions
        };
      });
    await updateSizesAndQuantities(newSizes);
    validateValues();
  }

  function toggleSizeGuide(preset = null) {
    setSizeGuidePreset(preset);
  }

  function getCorrectDimensionsFromMetadata() {
    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
    if (!isStandardArtwork() || store.catalogNumber !== "DTF001" || !artwork?.id) {
      return {
        width: artwork?.width,
        height: artwork?.height
      };
    }
    const { enhanceImage, enhancementTier, removeBackground, enhancedMetadata, originalMetadata } =
      artwork || {};
    let width;
    let height;
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    if (store.printAsIs || enhancementTier === "print_original") {
      width = originalMetadata?.widthInch || metadata()?.widthInch;
      height = originalMetadata?.heightInch || metadata()?.heightInch;
    } else if (enhanceImage && enhancementTier !== "custom") {
      if (removeBackground) {
        width = enhancedMetadata?.widthInch || metadata()?.widthInch;
        height = enhancedMetadata?.heightInch || metadata()?.heightInch;
      } else {
        width = artwork?.withBgMetadata?.widthInch || metadata()?.widthInch;
        height = artwork?.withBgMetadata?.heightInch || metadata()?.heightInch;
      }
    } else {
      width = originalMetadata?.widthInch || metadata()?.widthInch;
      height = originalMetadata?.heightInch || metadata()?.heightInch;
    }
    return {
      width: width || artwork?.width,
      height: height || artwork?.height
    };
  }

  async function updateDimensionsFromMetadata() {
    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
    if (!isStandardArtwork() || store.catalogNumber !== "DTF001" || !artwork?.id) {
      return;
    }
    const { width: customWidth, height: customHeight } = getCorrectDimensionsFromMetadata();
    if (!customWidth || !customHeight) return;
    const updatedSizes = sizesAndQuantities.map((sizeItem: any) => {
      if (sizeItem.preset === "custom") {
        return {
          ...sizeItem,
          width: customWidth,
          height: customHeight
        };
      }
      const newDimensions = calculatePresetDimensions({
        size: sizeItem.size,
        preset: sizeItem.preset
      });
      return {
        ...sizeItem,
        ...newDimensions
      };
    });
    await updateSizesAndQuantities(updatedSizes, false);
  }

  function handlePresetSelect({ preset, sizes }: any) {
    const isPresetPresent = preset in sizesGroupedByPreset();
    const rudderstackTrackProperties = {
      design_size_selection: preset,
      artwork_id: artwork.id,
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      design_dimensions: MAX_PRINT_SIZES_GROUPED[preset]
    };
    if (isPresetPresent) {
      const filteredSizes = sizesAndQuantities.filter((size: any) => size.preset !== preset);
      updateSizesAndQuantities(filteredSizes, true);
      trackRudderstackImagePlacementSelection("Removed", rudderstackTrackProperties);
    } else {
      const newSizes =
        preset === "custom"
          ? [
              {
                preset: "custom",
                width: getCorrectDimensionsFromMetadata().width,
                quantity: 1,
                height: getCorrectDimensionsFromMetadata().height,
                id: getRandomId()
              }
            ]
          : sizes.map((size: any) => ({
              ...(metadata()?.aspectRatio
                ? scaleToFitRatio(size.width, size.height, metadata().aspectRatio)
                : { width: size.width, height: size.height }),
              quantity: size.quantity ?? 0,
              size: getRangeString(size),
              id: getRandomId(),
              preset
            }));
      updateSizesAndQuantities([...sizesAndQuantities, ...newSizes], true);
      trackRudderstackImagePlacementSelection("Selected", rudderstackTrackProperties);
    }
  }

  function updateArtworksPricingAndTrackSizeChange(oldPrice: any, newPrice: any) {
    if (isArtworkLoading()) return;
    const eventPayload = {
      product_line: sticker() ? "sticker" : proColor() ? "pro color" : "dtf",
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      business_line: store.businessLine,
      artwork,
      edit_type: editType(),
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworks_count: store.artworks.length,
      location: "pdp",
      old_price: oldPrice,
      new_price: newPrice
    };
    if (backgroundChanged.changed) {
      // @ts-expect-error TS(2339): Property 'remove_background_toggle_switch' does no... Remove this comment to see the full error message
      eventPayload.remove_background_toggle_switch = backgroundChanged.isBgRemoved
        ? "switched_on"
        : "switched_off";
      setBackgroundChanged({
        changed: false,
        isBgRemoved: false
      });
    }
    setSizeChanged(false);
    trackRudderstackImageEdited(eventPayload);
  }

  function totalPrice(sizeId: any) {
    const size = sizesAndQuantities.find(({ id }: any) => id === sizeId);
    // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
    const pricing = size?.unitPrice ? size : store.simulation;
    const artworkId = String(artwork?.id);
    const sizeKey = `${size.width}x${size.height}`;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const bogoPrice = store.getBogoAdjustedPrice(artworkId, sizeId, sizeKey);
    if (bogoPrice) {
      return bogoPrice.discountedTotalPrice.toFixed(2);
    }
    return (pricing.unitPrice * size.quantity).toFixed(2);
  }

  function isFieldInValid(id: any) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return errors[id] && errors[id].message && !errors[id].isFieldValid;
  }

  function addSize() {
    const dimensions = getCorrectDimensionsFromMetadata();
    const newValue = {
      preset: "custom",
      id: getRandomId(),
      quantity: 1,
      width: dimensions.width,
      height: dimensions.height
    };
    updateSizesAndQuantities([...sizesAndQuantities, newValue], true);
    submitDtfEvent("multi_size_artwork", {
      // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
      pdp_type: store.pdpType,
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      business_line: store.businessLine,
      page: "pdp",
      action: "add_size",
      size_count: sizesAndQuantities.length
    });
    trackRudderstackImagePlacementSelection("Size Added", {
      design_size_selection: "custom",
      artwork_id: artwork.id,
      design_dimensions: [
        {
          width: newValue.width,
          height: newValue.height
        }
      ],

      quantity: 1
    });
  }

  function removeSize(e: any) {
    const { sizeIndex } = e.target.dataset;
    const targetSize = sizesAndQuantities[Number(sizeIndex)];
    updateSizesAndQuantities(
      sizesAndQuantities.filter((_: any, idx: any) => idx !== Number(sizeIndex)),
      true
    );
    submitDtfEvent("multi_size_artwork", {
      // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
      pdp_type: store.pdpType,
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      business_line: store.businessLine,
      page: "pdp",
      action: "remove_size",
      size_count: sizesAndQuantities.length
    });
    trackRudderstackImagePlacementSelection("Size Removed", {
      design_size_selection: "custom",
      artwork_id: artwork.id,
      design_dimensions: [
        {
          width: targetSize.width,
          height: targetSize.height
        }
      ],

      quantity: targetSize.quantity
    });
  }

  function trackSizeChanges(newData: any, oldData: any, quantity: any) {
    if (
      isArtworkLoading() ||
      (newData?.width === oldData?.width && newData?.height === oldData?.height)
    )
      return;
    let sizeChange;
    const area = newData.width * newData.height;
    const oldArea = oldData.width * oldData.height;
    if (area === 0 && oldArea === 0) {
      sizeChange = "none";
    } else if (area > oldArea) {
      sizeChange = "larger";
    } else {
      sizeChange = "smaller";
    }
    const sizePercentChange =
      oldArea === 0 ? 0 : Math.round((Math.abs(area - oldArea) / oldArea) * 100);
    submitDtfEvent("size_modified", {
      width: newData.width,
      height: newData.height,
      previous_width: oldData.width,
      previous_height: oldData.height,
      size_change: sizeChange,
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      business_line: store.businessLine,
      size_percent_change: sizePercentChange,
      // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
      has_image: !store.simulation,
      page: "pdp",
      // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
      pdp_type: store.pdpType
    });
    trackRudderstackImagePlacementSelection("Size Edited", {
      design_size_selection: "custom",
      artwork_id: artwork.id,
      design_dimensions: [
        {
          width: newData.width,
          height: newData.height
        }
      ],

      quantity
    });
  }

  function onBlur(e: any) {
    const { sizeIndex } = e.target.dataset;
    const dimension = sizesAndQuantities[sizeIndex];
    const currentData = {
      width: dimension.width,
      height: dimension.height
    };
    if (isEqual(currentData, previousData[sizeIndex])) {
      return;
    }
    validateValues();
    if (isWidthAndHeightValid(dimension)) {
      trackSizeChanges(currentData, previousData[sizeIndex], dimension.quantity);
      setPreviousData(prev => {
        const newPrev = [...prev];
        newPrev[sizeIndex] = currentData;
        return newPrev;
      });
      getNewPricingAndDates();
      setSizeChanged(true);
    }
  }

  function buildRudderstackTrackProperties(idx: any, sizeData: any, quantity: any) {
    const { preset } = sizesAndQuantities[idx];
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const designDimensions = MAX_PRINT_SIZES_GROUPED[preset];
    return {
      design_size_selection: preset,
      artwork_id: artwork.id,
      design_dimensions: designDimensions,
      blanks_size: sizeData.size?.trim(),
      quantity
    };
  }

  function updateQuantity(value: any, idx: any) {
    const currentSizes = getStoreArtwork()?.sizesAndQuantities || sizesAndQuantities;
    updateSizesAndQuantities(
      currentSizes.map((size: any, itemIdx: any) => {
        if (idx === itemIdx) {
          const quantity = value.length > 0 ? Math.max(1, Number(value)) : value;
          const previousQuantity = Number(size.quantity) || 0;
          const trackProperties = buildRudderstackTrackProperties(idx, size, quantity);
          trackRudderstackImagePlacementQuantity(trackProperties);
          submitDtfEvent("dtf_artwork_quantity_change", {
            artwork_id: artwork.id,
            size_index: idx,
            preset: size.preset,
            previous_quantity: previousQuantity,
            quantity,
            // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
            business_line: store.businessLine,
            // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
            pdp_type: store.pdpType,
            is_multi_upload: isMultiUpload,
            design_dimensions: trackProperties.design_dimensions,
            blanks_size: trackProperties.blanks_size
          });
          return {
            ...size,
            quantity
          };
        }
        return size;
      }),
      true
    );
    if (idx === 0) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.setSimulation({
        quantity: value
      });
    }
    getNewPricingAndDates();
  }

  function autoFillInputs(field: any, inputValue: any, sizeIndex: any) {
    if (!artwork || !sizesAndQuantities[sizeIndex]) return;
    const value = Number(inputValue) > MAX_SIZE_FIELD_VALUE ? MAX_SIZE_FIELD_VALUE : inputValue;
    let newDimensions = {
      width: sizesAndQuantities[sizeIndex].width,
      height: sizesAndQuantities[sizeIndex].height
    };
    setPreviousData(prev => {
      const newPrev = [...prev];
      newPrev[sizeIndex] = {
        ...newDimensions
      };
      return newPrev;
    });
    if (field === "width") {
      newDimensions = {
        width: value,
        height: getProportionalEdge({
          value,
          field: "height",
          aspectRatio: metadata()?.aspectRatio,
          currentDimensions: sizesAndQuantities[sizeIndex]
        })
      };
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.setSimulation({
        widthEdited: true
      });
    }
    if (field === "height") {
      newDimensions = {
        width: getProportionalEdge({
          value,
          field: "width",
          aspectRatio: metadata()?.aspectRatio,
          currentDimensions: sizesAndQuantities[sizeIndex]
        }),
        height: value
      };
    }
    const newSizesAndQuantities = sizesAndQuantities.map((item: any, idx: any) =>
      idx === sizeIndex
        ? {
            ...item,
            ...newDimensions
          }
        : item
    );
    if (sizeIndex === 0) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.setSimulation({
        ...newDimensions
      });
    }
    const editedSizeId = sizesAndQuantities[sizeIndex].id;
    updateSizesAndQuantities(newSizesAndQuantities, true);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: artwork.originalIndex,
      lastEditedSizeId: editedSizeId
    });
  }

  function handleValueInput(target: any) {
    const {
      value,
      dataset: { sizeIndex, field }
    } = target;
    if (field === "quantity") {
      updateQuantity(value, Number(sizeIndex));
    } else {
      resetErrors();
      autoFillInputs(field, value, Number(sizeIndex));
      if (Number(value) > MAX_SIZE_FIELD_VALUE) {
        validateValues();
      }
    }
  }

  function handleInputClick(e: any) {
    e.target.focus();
  }

  // eslint-disable-next-line no-shadow
  function handleQuantityUpdate({ value, index }: any) {
    // eslint-disable-line no-shadow
    const val = Number(value) > MAX_QUANTITY_VALUE ? MAX_QUANTITY_VALUE : value;
    const valueObject = {
      value: val,
      dataset: {
        sizeIndex: index,
        field: "quantity"
      }
    };
    handleValueInput(valueObject);
  }

  function getSizesFingerprint(sizes: any) {
    return sizes.map((s: any) => `${s.id}:${s.quantity}`).join(",");
  }

  useEffect(() => {
    if (!artwork) return;
    if (artwork.isFile || artwork.isSimulated) return;
    if (!!artwork.metadata?.errors && !artwork.isValid) return;
    if (prevArtworkRef.current?.removeBackground !== artwork.removeBackground) {
      setBackgroundChanged({
        changed: true,
        isBgRemoved: artwork.removeBackground
      });
    }
    prevArtworkRef.current = artwork;
  }, [artwork]);

  useEffect(() => {
    if (artwork?.isFile || artwork?.isSimulated) return;
    // @ts-expect-error TS(6133): 'currentFingerprint' is declared but its value is ... Remove this comment to see the full error message
    const currentFingerprint = getSizesFingerprint(artwork?.sizesAndQuantities || []);
    validateValues();
  }, [artwork?.sizesAndQuantities]);

  useEffect(() => {
    const debouncedHandler = debounce(newArtwork => {
      if (newArtwork.isFile || newArtwork.isSimulated) return;
      if (!!newArtwork.metadata?.errors && !newArtwork.isValid) return;
      const oldArtwork = prevArtworkRef.current;
      const oldArtworkSizePrices =
        oldArtwork?.sizesAndQuantities?.map(({ unitPrice }: any) => unitPrice) || [];
      const newArtworkSizePrices =
        newArtwork.sizesAndQuantities?.map(({ unitPrice }: any) => unitPrice) || [];
      const bgChanged = backgroundChangedRef.current.changed;
      if (
        !isPricingLoading() &&
        oldArtworkSizePrices.length === newArtworkSizePrices.length &&
        (!isEqual(oldArtworkSizePrices, newArtworkSizePrices) || bgChanged)
      ) {
        oldArtworkSizePrices.forEach((oldPrice: any, idx: any) => {
          if ((oldPrice && oldPrice !== newArtworkSizePrices[idx]) || bgChanged) {
            updateArtworksPricingAndTrackSizeChange(oldPrice, newArtworkSizePrices[idx]);
          }
        });
      }
      const enhancementSwitched = newArtwork.enhancementTier !== oldArtwork?.enhancementTier;
      if ((oldArtwork?.isLoading && !newArtwork.isLoading) || bgChanged || enhancementSwitched) {
        validateValues();
      }
    }, 300);

    debouncedHandler(artwork);

    return () => {
      debouncedHandler.cancel();
    };
  }, [artwork]);

  useLayoutEffect(() => {
    const newMetadata = metadata();
    if (
      newMetadata &&
      prevMetadataRef.current &&
      // @ts-expect-error TS(2339): Property 'aspectRatio' does not exist on type 'nev... Remove this comment to see the full error message
      newMetadata.aspectRatio !== prevMetadataRef.current.aspectRatio
    ) {
      recalculateSizes();
    }
    prevMetadataRef.current = newMetadata;
  }, [metadata()?.aspectRatio]);

  useLayoutEffect(() => {
    if (!artwork?.isFile && !artwork?.isSimulated && !artwork?.isLoading && artwork?.id) {
      updateDimensionsFromMetadata();
    }
  }, [
    artwork?.enhanceImage,
    artwork?.enhancementTier,
    artwork?.removeBackground,
    artwork?.isLoading,
    artwork?.id,
    artwork?.originalMetadata?.widthInch,
    artwork?.withBgMetadata?.widthInch,
    artwork?.enhancedMetadata?.widthInch
  ]);

  useLayoutEffect(() => {
    if (!artwork?.isFile && !artwork?.isSimulated && !artwork?.isLoading && artwork?.id) {
      updateDimensionsFromMetadata();
    } else {
      recalculateSizes();
    }
  }, []);

  return (
    <>
      <div
        className={cn(
          "artwork-multi-dimensions scope-61b2986e",
          isMultiUpload && "artwork-multi-dimensions--multi-upload",
          restClassName
        )}
        {...restProps}
      >
        {isArtworkUploaded() && showMultiSize() ? (
          <PresetSelector
            className="scope-61b2986e"
            sizePresets={sizePresets()}
            selectedPresets={selectedPresets()}
            disabled={!isArtworkUploaded()}
            artworkUrl={artworkUrl()}
            isMultiUpload={isMultiUpload}
            index={index}
            onSelect={handlePresetSelect}
            data-testid="preset-selector"
          />
        ) : null}
        {showFreeTransfersBadge ? (
          <div className="artwork-multi-dimensions__free-transfers-badge-wrapper scope-61b2986e">
            <FreeTransfersBadge
              className="artwork-multi-dimensions__free-transfers-badge scope-61b2986e"
              message={freeTransfersBadgeMessage()}
              data-testid="artwork-multi-dimensions-free-transfers-badge"
            />
          </div>
        ) : null}
        {renderList(Object.values(sizesGroupedByPreset()), presetSize => (
          <Fragment key={presetSize.preset}>
            {presetSize.preset === "custom" ? (
              <MultiSizeGroup
                className="scope-61b2986e"
                count={presetSize.count}
                price={presetSize.price}
                title="Custom Size"
                showTitle={isArtworkUploaded()}
                showDeleteButton={selectedPresets().length > 1}
                onDelete={handlePresetSelect}
                slots={{
                  footer: () => (
                    <>
                      {isArtworkUploaded() ? (
                        <button
                          className={cn("artwork-multi-dimensions__add-button scope-61b2986e", {
                            "artwork-multi-dimensions__add-button--standard-artwork":
                              isStandardArtwork()
                          })}
                          type="button"
                          onClick={addSize}
                          data-testid="artwork-multi-dimensions-add-button"
                        >
                          {" "}
                          Add another size{" "}
                        </button>
                      ) : null}
                    </>
                  )
                }}
                data-testid="multi-size-group"
              >
                {renderList(presetSize.items, (size, sizeIndex) => (
                  <div
                    className={cn("artwork-multi-dimensions__form-number-row scope-61b2986e", {
                      "artwork-multi-dimensions__form-number-row--first": sizeIndex === 0
                    })}
                    key={sizeIndex}
                  >
                    <div className="artwork-multi-dimensions__form-number-row-content scope-61b2986e">
                      <div
                        className={cn("artwork-multi-dimensions__control scope-61b2986e", {
                          "artwork-multi-dimensions__control--gang-lock":
                            gangPadlock() && !!artwork?.width
                        })}
                      >
                        {sizeIndex === 0 ? (
                          <label
                            className="artwork-multi-dimensions__label scope-61b2986e"
                            htmlFor={widthId()}
                            data-testid="artwork-multi-dimensions-label"
                          >
                            {" "}
                            Width (Inch){" "}
                          </label>
                        ) : null}
                        <input
                          className={cn(
                            "artwork-multi-dimensions__field artwork-multi-dimensions__field--number js-dtf-width-input scope-61b2986e",
                            {
                              "artwork-multi-dimensions__field--invalid": isFieldInValid(size.id)
                            }
                          )}
                          id={widthId()}
                          value={size.width ?? ""}
                          max="100"
                          min="0.1"
                          name={widthId()}
                          step=".01"
                          type="number"
                          data-hj-allow={true}
                          data-size-index={size.index}
                          data-field="width"
                          disabled={disableFields()}
                          readOnly={readonly}
                          onClick={handleInputClick}
                          onInput={e => handleValueInput(e.target)}
                          onBlur={onBlur}
                          data-testid="artwork-multi-dimensions-field"
                        />
                      </div>
                      <UseSvg
                        className="artwork-multi-dimensions__multiplier scope-61b2986e"
                        icon="cross"
                        data-testid="artwork-multi-dimensions-multiplier"
                      />

                      <div
                        className={cn("artwork-multi-dimensions__control scope-61b2986e", {
                          "artwork-multi-dimensions__control--gang-lock": lockHeight()
                        })}
                      >
                        {sizeIndex === 0 ? (
                          <label
                            className="artwork-multi-dimensions__label scope-61b2986e"
                            htmlFor={heightId()}
                            data-testid="artwork-multi-dimensions-label-1"
                          >
                            {heightLabel()}
                          </label>
                        ) : null}
                        <input
                          className={cn(
                            "artwork-multi-dimensions__field artwork-multi-dimensions__field--number js-dtf-height-input scope-61b2986e",
                            {
                              "artwork-multi-dimensions__field--invalid": isFieldInValid(size.id)
                            }
                          )}
                          id={heightId()}
                          value={size.height ?? ""}
                          max="100"
                          min="0.1"
                          name={heightId()}
                          step=".01"
                          type="number"
                          data-hj-allow={true}
                          data-size-index={sizeIndex}
                          data-field="height"
                          disabled={disableFields()}
                          readOnly={readonlyHeight()}
                          onClick={handleInputClick}
                          onInput={e => handleValueInput(e.target)}
                          onBlur={onBlur}
                          data-testid="artwork-multi-dimensions-field-1"
                        />
                      </div>
                      <div className="artwork-multi-dimensions__control artwork-multi-dimensions__control--quantity scope-61b2986e">
                        {sizeIndex === 0 ? (
                          <label
                            className="artwork-multi-dimensions__label scope-61b2986e"
                            htmlFor="quantity"
                            data-testid="artwork-multi-dimensions-label-2"
                          >
                            {" "}
                            Quantity{" "}
                          </label>
                        ) : null}
                        <QuantityInput
                          className="scope-61b2986e"
                          quantity={size.quantity}
                          index={sizeIndex}
                          disabled={disableFields()}
                          isMultiUpload={isMultiUpload}
                          variantId={variantId()}
                          onChange={handleQuantityUpdate}
                          data-testid="quantity-input"
                        />

                        {showPricing() ? (
                          <div
                            className={cn("artwork-multi-dimensions__price scope-61b2986e", {
                              "artwork-multi-dimensions__price--loading":
                                isPricingLoading() || size.quantity === 0
                            })}
                          >
                            {n(totalPrice(size.id), "currency")}
                          </div>
                        ) : null}
                      </div>
                      {sizesAndQuantities.length > 1 ? (
                        <button
                          className="artwork-multi-dimensions__remove-button scope-61b2986e"
                          type="button"
                          data-size-index={sizeIndex}
                          onClick={removeSize}
                          data-testid="artwork-multi-dimensions-remove-button"
                        >
                          <UseSvg
                            className="artwork-multi-dimensions__remove-button-icon scope-61b2986e"
                            icon="trash"
                            data-testid="artwork-multi-dimensions-remove-button-icon"
                          />
                        </button>
                      ) : null}
                    </div>
                    {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
                    {errors[size.id] ? (
                      <div className="artwork-multi-dimensions__error-message scope-61b2986e">
                        {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
                        {errors[size.id].message}
                      </div>
                    ) : null}
                  </div>
                ))}
              </MultiSizeGroup>
            ) : (
              <MultiSizeGroup
                className="scope-61b2986e"
                isPreset={true}
                count={presetSize.count}
                price={presetSize.price}
                title={presetSize.preset}
                showDeleteButton={selectedPresets().length > 1}
                onDelete={handlePresetSelect}
                onOpenSizeGuide={toggleSizeGuide}
                data-testid="multi-size-group-1"
              >
                <CustomSizeSelector
                  className="scope-61b2986e"
                  preset={presetSize.preset}
                  sizes={presetSize.items}
                  artworkId={String(artwork?.id)}
                  // @ts-expect-error TS(2571): Object is of type 'unknown'.
                  errors={errorGroupedByPreset()[presetSize.preset]}
                  onChange={handleQuantityUpdate}
                  data-testid="custom-size-selector"
                />
              </MultiSizeGroup>
            )}
          </Fragment>
        ))}
        {!printAsIs() && !disabled ? (
          <div className="artwork-multi-dimensions__free-note scope-61b2986e">
            {" "}
            Padding for easy cutting is added for free{" "}
          </div>
        ) : null}
      </div>
      {sizeGuidePreset ? (
        <SizeGuide
          className="scope-61b2986e"
          preset={sizeGuidePreset}
          onClose={toggleSizeGuide}
          data-testid="size-guide"
        />
      ) : null}
    </>
  );
}

export default ArtworkMultiDimensions;
